/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerRemoveMutationResponse, FilesControllerRemovePathParams, FilesControllerRemoveQueryParams, FilesControllerRemove401, FilesControllerRemove403, FilesControllerRemove404 } from "../../models/filesController/FilesControllerRemove";

function getFilesControllerRemoveUrl(id: FilesControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/files/${id}` as const }  
  return res
}

/**
 * @description Deletes a file. By default, performs a soft delete (marks as deleted but keeps in database for recovery). Use hardDelete=true to permanently remove the file and its scope from the database.
 * @summary Delete a file
 * {@link /api/v1/files/:id}
 */
export async function filesControllerRemove(id: FilesControllerRemovePathParams["id"], params?: FilesControllerRemoveQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerRemoveMutationResponse, ResponseErrorConfig<FilesControllerRemove401 | FilesControllerRemove403 | FilesControllerRemove404>, unknown>({ method : "DELETE", url : getFilesControllerRemoveUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}